import { generatePath } from "react-router-dom";

import { Locale } from "@/constants";
import { User } from "@/types/User";

import fetcher_v2, { ErrorMessages } from "../fetcher_v2";
import { URLS } from "../urls";

type ActivationData = {
  first_name: string;
  last_name: string;
  password: string;
  activation_key: string;
  email?: string;
};

export const activate = (body: ActivationData) => {
  return fetcher_v2<User, ActivationData, ErrorMessages<ActivationData>>(
    URLS.USER_ACTIVATE,
    {
      body,
      method: "POST",
    }
  );
};

export const fetchUser = (uuid: string) => {
  return fetcher_v2<User>(generatePath(URLS.USER, { uuid }), {
    method: "GET",
  });
};

type UnactivatedUser = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  language: Locale;
};

export const validateActivationKey = (activation_key: string) => {
  return fetcher_v2<UnactivatedUser>(URLS.USER_ACTIVATE, {
    body: { activation_key },
    method: "GET",
  });
};

type AuthUserPayload = {
  username: string;
  password: string;
};

export const authorizeUser = (auth: AuthUserPayload) => {
  return fetcher_v2<User>(URLS.LOGIN, {
    body: auth,
    method: "POST",
  });
};

export type ChangePasswordPayload = {
  password: string;
  new_password: string;
  new_password_confirm: string;
};

export const changePassword = (data: ChangePasswordPayload) => {
  return fetcher_v2<unknown, ChangePasswordPayload, { error: string }>(
    URLS.USER_SET_PASSWORD,
    {
      method: "POST",
      body: data,
    }
  );
};
